import React, { useState, useEffect, useContext } from 'react';
import Swal from 'sweetalert2';
import AppContext from '../../../../context/AppContext';

const RecentOrders = () => {
  const [orderFilter, setOrderFilter] = useState('All');
  const [allOrders, setAllOrders] = useState([]);
  const { baseUrl } = useContext(AppContext);

  // NEW
  useEffect(() => {
    fetch(`${baseUrl}/admin/recent-orders`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('adminToken')}`,
        Accept: 'application/json',
      },
    })
      .then(res => res.json())
      .then(data => setAllOrders(Array.isArray(data) ? data : []))
      .catch(() => setAllOrders([]));
  }, []);

  const filteredOrders = orderFilter === 'All'
    ? allOrders
    : orderFilter === 'Shipped'
      ? allOrders.filter(order => order.status === 'Delivered')
      : allOrders.filter(order => order.status === 'Processing');

  const handleViewOrder = (order) => {
    Swal.fire({
      title: `<strong style="color: var(--primary-color);">${order.id}</strong>`,
      html: `
        <div style="text-align: left; padding: 20px; background: var(--bg-light); border-radius: 12px; margin-top: 15px;">
          <div style="margin-bottom: 15px; padding-bottom: 15px; border-bottom: 2px solid var(--border-color);">
            <p style="color: var(--text-muted); font-size: 12px; margin: 0; text-transform: uppercase; letter-spacing: 1px;">Product</p>
            <p style="color: var(--text-primary); font-size: 16px; font-weight: 600; margin: 5px 0 0 0;">${order.product}</p>
          </div>
          <div style="margin-bottom: 15px; padding-bottom: 15px; border-bottom: 2px solid var(--border-color);">
            <p style="color: var(--text-muted); font-size: 12px; margin: 0; text-transform: uppercase; letter-spacing: 1px;">Customer</p>
            <p style="color: var(--text-primary); font-size: 16px; font-weight: 600; margin: 5px 0 0 0;">${order.customer}</p>
          </div>
          <div style="margin-bottom: 15px; padding-bottom: 15px; border-bottom: 2px solid var(--border-color);">
            <p style="color: var(--text-muted); font-size: 12px; margin: 0; text-transform: uppercase; letter-spacing: 1px;">Date</p>
            <p style="color: var(--text-primary); font-size: 16px; font-weight: 600; margin: 5px 0 0 0;">${order.date}</p>
          </div>
          <div style="margin-bottom: 15px; padding-bottom: 15px; border-bottom: 2px solid var(--border-color);">
            <p style="color: var(--text-muted); font-size: 12px; margin: 0; text-transform: uppercase; letter-spacing: 1px;">Amount</p>
            <p style="color: var(--primary-color); font-size: 24px; font-weight: 700; margin: 5px 0 0 0;">Rs ${Number(order.amount).toFixed(2)}</p>
          </div>
          <div>
            <p style="color: var(--text-muted); font-size: 12px; margin: 0; text-transform: uppercase; letter-spacing: 1px;">Status</p>
            <p style="
              color: ${order.status === 'Delivered' ? 'var(--status-success)' : 'var(--status-warning)'}; 
              font-size: 16px; 
              font-weight: 700; 
              margin: 5px 0 0 0;
              background: ${order.status === 'Delivered' ? '#dcfce7' : '#fef3c7'};
              padding: 8px 16px;
              border-radius: 8px;
              display: inline-block;
            ">${order.status}</p>
          </div>
        </div>
      `,
      icon: 'info',
      iconColor: 'var(--primary-color)',
      confirmButtonText: 'Close',
      confirmButtonColor: 'var(--primary-color)',
      customClass: {
        popup: 'custom-swal-popup',
        confirmButton: 'custom-swal-button'
      },
      width: '500px'
    });
  };

  return (
    <div className="AdminSideDashboard__ordersSection AdminSideDashboard--slideUp" style={{ animationDelay: '0.5s' }}>
      <div className="AdminSideDashboard__ordersHeader">
        <h2 className="AdminSideDashboard__sectionTitle">Recent Orders</h2>
        <div className="AdminSideDashboard__orderFilters">
          <button 
            className={`AdminSideDashboard__filterBtn ${orderFilter === 'All' ? 'AdminSideDashboard__filterBtn--active' : ''}`}
            onClick={() => setOrderFilter('All')}
          >
            All
          </button>
          <button 
            className={`AdminSideDashboard__filterBtn ${orderFilter === 'Shipped' ? 'AdminSideDashboard__filterBtn--active' : ''}`}
            onClick={() => setOrderFilter('Shipped')}
          >
            Completed
          </button>
          <button 
            className={`AdminSideDashboard__filterBtn ${orderFilter === 'Pending' ? 'AdminSideDashboard__filterBtn--active' : ''}`}
            onClick={() => setOrderFilter('Pending')}
          >
            Pending
          </button>
        </div>
      </div>

      <div className="AdminSideDashboard__ordersTable">
        <table className="AdminSideDashboard__table">
          <thead>
            <tr>
              <th>ORDER ID</th>
              <th>PRODUCT</th>
              <th>CUSTOMER</th>
              <th>DATE</th>
              <th>AMOUNT</th>
              <th>STATUS</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {filteredOrders.map((order, index) => (
              <tr 
                key={order.id}
                className="AdminSideDashboard--fadeInUp"
                style={{ animationDelay: `${0.05 * index}s` }}
              >
                <td className="AdminSideDashboard__orderId">{order.id}</td>
                <td>
                  <div className="AdminSideDashboard__orderProduct">
                    <div className="AdminSideDashboard__orderProductImage">📦</div>
                    {order.product}
                  </div>
                </td>
                <td>{order.customer}</td>
                <td>{order.date}</td>
                <td className="AdminSideDashboard__orderAmount">Rs {Number(order.amount).toFixed(2)}</td>
                <td>
                  <span className={`AdminSideDashboard__orderStatus AdminSideDashboard__orderStatus--${order.status.toLowerCase()}`}>
                    {order.status}
                  </span>
                </td>
                <td>
                  <button 
                    className="AdminSideDashboard__viewBtn"
                    onClick={() => handleViewOrder(order)}
                    title="View Details"
                  >
                    👁
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RecentOrders;